import axios from 'axios';

const API_URL = '/omaviihde/api/cardlink';

export const CARD_READER_ADD = 'CARD_READER_ADD';
export const CARD_READER_DELETE = 'CARD_READER_DELETE';
export const CARD_READER_ERROR = 'CARD_READER_ERROR';

export function addCardReader(readerID) {
  return dispatch => {
    const id = readerID.replace(/\s/g, '');
    if (!/^\d+$/.test(id)) {
      return dispatch({ type: CARD_READER_ERROR, error: 'Kortinlukijan tunnisteessa tulee olla vain numeroita.' });
    }

    return axios.post(API_URL, id, { headers: { 'Content-Type': 'text/plain' } })
      .then(() => {
          dispatch({ type: CARD_READER_ADD, id });
        }
      )
      .catch(() => {
          dispatch({ type: CARD_READER_ERROR, error: 'Kortinlukijan lisääminen ei onnistunut.' });
        }
      );
  };
}

export function deleteCardReader(readerID) {
  return dispatch => {
    return axios.delete(`${API_URL}/${readerID}`)
      .then(() => {
          dispatch({ type: CARD_READER_DELETE, id: readerID });
        }
      );
  };
}



// WEBPACK FOOTER //
// ./web/js/stores/actions/cardReader.js